const pathMap = {
  "/signup": undefined,
  "/signup/entry": undefined,
  "/signup/form": undefined,
  "/signup/complete": undefined,

  "/estimate/input-title": undefined,
  "/estimate/save/individual/form": undefined,
  "/estimate/save/individual/confirm": undefined,
  "/estimate/save/individual/complete": undefined,

  "/seminar/entry/form": undefined,
  "/seminar/entry/confirm": undefined,
  "/seminar/entry/complete": undefined,

  "/campaign/entry/form": undefined,
  "/campaign/entry/confirm": undefined,
  "/campaign/entry/complete": undefined,
} as const

export default pathMap
